//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CategoryProductListLoading from '~/components/organisms/Category/Loading/CategoryProductListLoading.vue';
export default {
  name: 'CategoryLoading',
  components: {
    CategoryProductListLoading: CategoryProductListLoading
  },
  props: {
    search: {
      type: Boolean,
      default: false
    }
  }
};